import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared';

import { injectSupplySlice } from '@/app/supplyApi';

// import './mockApi';
import { UserPermissionType } from './types';

export const permissionsApi = injectSupplySlice({
  baseUrl: Config.VITE_API_URL + '/users',
  tagTypes: ['UserPermissions'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getUserPermissions: builder.query<UserPermissionType[], void>({
      query: () => ({
        url: `/permissions`,
      }),
      providesTags: ['UserPermissions'],
    }),
  }),
});

export const { useGetUserPermissionsQuery } = permissionsApi;
